<script>
import {mapState} from "vuex";

export default {
  name: "productView",
  props: {
    ofoFlowWork: Object,
    ofoFlowDeal: Object,
    productsList: Array,
    thingsList: Array,
    workConfig: Object,
    limit: {
      type: Object,
      default: ()=>({})
    },
    params: {
      type: Object,
      default: () => ({
        priceAccuracy: 2,
        quantityAccuracy: 8,
        bzhs: '1',
        deptName: null
      })
    }
  },
  computed: {
    ...mapState({
      dropDown: state => state.dropDown.dropDown,
    }),
  },
  data () {
    return {
      allShow: true,
      confirmResShow: {}
    }
  },
  async created () {
  },
  methods: {
    cbowhName(number) {
      if(number == 1) {
        return this.ofoFlowWork.stockaccttype == '7' ? '调出位置' : '位置'
      }else {
        return this.ofoFlowWork.stockaccttype == '7' ? '调入位置' : '位置2'
      }
    },
    comdifyPrams(n) {
      if(!n) return '';
      // console.log(this.params.priceAccuracy);
      n = Number(n).toFixed(this.params.priceAccuracy)
      // console.log(n);
      let res01 = n.split(".")[0];
      let res02 = n.split(".")[1];
      // console.log(`${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`);
      return `${res01}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + `.${res02}`;
    },
  }
}
</script>

<template>
  <el-table
    :data="productsList"
    :header-cell-style="{background: '#F9F9FB',color:'#606266','text-align': 'center'}"
    border
    row-key="ofoWorkResourceId"
    ref="noEditTable"
    :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
    >
    <el-table-column type="expand" v-if="thingsList && thingsList.length > 0">
      <template slot-scope="props">
        <el-table
          v-if="thingsList.filter(item => item.uuid ? item.uuid === props.row.uuid : item.ofrresourceId == props.row.ofrresourceId).length"
          :data="thingsList.filter(item => item.uuid ? item.uuid === props.row.uuid : item.ofrresourceId == props.row.ofrresourceId)"
          :header-cell-style="{background:'#F9F9FB',color:'#606266','text-align': 'center'}"
          key="table2"
          ref="noEditTable2"
          row-key="ofoWorkThingId"
          border
          style="margin-left:50px">
          <el-table-column
            type="index"
            label="行号"
            width="50">
          </el-table-column>
          <!-- 位置 -->
          <el-table-column
            prop="cbowhName"
            :label="cbowhName(1)"
            width="115"
            v-if="ofoFlowWork.chooseOwh == '0'">
          </el-table-column>
          <!-- 位置2 -->
          <el-table-column
            prop="cbowhToName"
            :label="cbowhName(2)"
            width="115"
            v-if="ofoFlowWork.stockaccttype == '7'">
          </el-table-column>
          <!-- 货物或应税劳务、服务名称 -->
          <el-table-column
            :label="ofoFlowWork.thingtypeName + '（明细）'"
            min-width="200"
            prop="ofrresourceName">
            <template slot-scope="scope">
              <a class="link">{{scope.row.ofrresourceName + ' - ' + scope.row.ofrthingName}}</a>
            </template>
          </el-table-column>
          <!-- 自定义 -->
          <el-table-column
            :prop="'customize' + item.ofoFlowWorkConfigId"
            min-width="150"
            align="center"
            v-for="(item, index) in workConfig.workConfigList4"
            :key="item.ofoFlowWorkConfigId"
            :label="item.name">
            <template slot-scope="scope">
              <DictTag :options="JSON.parse(scope.row.workConfigList4[index].options)" :value="scope.row.workConfigList4[index].configValue" v-if="scope.row.workConfigList4[index].showType == '2'"/>
              <template v-else-if="scope.row.workConfigList4[index].showType == '1'">
                {{scope.row.workConfigList4[index].configValue}}
                <span v-if="scope.row.workConfigList4[index].showType == '1' && scope.row.workConfigList4[index].configValue">%</span>
              </template>
              <template v-else>
                {{scope.row.workConfigList4[index].configValue}}
              </template>
            </template>
          </el-table-column>
          <!-- 包装核算 -->
          <template v-if="params.bzhs === '0' && ofoFlowWork.bzhs === '0'">
            <el-table-column
              prop="bzsl"
              label="包装数量"
              min-width="150">
            </el-table-column>
            <el-table-column
              prop="bzdw"
              label="包装单位"
              min-width="120">
            </el-table-column>
            <el-table-column
              prop="bzxs"
              label="包装系数"
              min-width="120">
            </el-table-column>
          </template>
          <!-- <el-table-column v-for="(item, index) in obussDimeList" :key="index" :label="item.dimeName" :prop="item.dimeValue">
            <template slot-scope="scope">
              <span>{{scope.row.obussDimeList[index].dimeValue}}</span>
            </template>
          </el-table-column> -->
          <!-- 起始数量 -->
          <el-table-column
            prop="beginValue"
            label="起始数量"
            min-width="100"
            v-if="ofoFlowWork.costmanagetype == '8'">
          </el-table-column>
          <!-- 终止数量 -->
          <el-table-column
            prop="endValue"
            label="终止数量"
            min-width="100"
            v-if="ofoFlowWork.costmanagetype == '8'">
          </el-table-column>
          <!-- 数量期间 -->
          <el-table-column
            prop="quantity"
            label="数量"
            min-width="100"
            v-if="ofoFlowWork.costmanagetype == '8'">
            <template slot-scope="scope">{{scope.row.quantity}}
            </template>
          </el-table-column>
          <!-- 数量 -->
          <el-table-column
            :prop="'quantity' + item.ofoFlowWorkConfigId"
            min-width="150"
            align="right"
            v-for="(item, index) in workConfig.workConfigList1"
            :key="item.ofoFlowWorkConfigId"
            :label="item.name"
            v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '4'">
            <template slot-scope="scope">
              <DictTag :options="JSON.parse(scope.row.workConfigList1[index].options)" :value="scope.row.workConfigList1[index].configValue" v-if="scope.row.workConfigList1[index].showType == '2'"/>
              <div v-else>
                {{scope.row.workConfigList1[index].configValue}}
                <span v-if="scope.row.workConfigList1[index].showType == '1' && scope.row.workConfigList1[index].configValue">%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="数量"
            min-width="150"
            align="right"
            header-align="center"
            v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8'">
          </el-table-column>
          <el-table-column
            prop="quantityKz"
            label="(控制)数量"
            min-width="150"
            align="right"
            v-if="limit.quantity && limit.quantity.limitRate">
            <template slot-scope="scope">
              {{scope.row.ofoFlowWorkLimitShow.quantity}}
            </template>
          </el-table-column>
          <el-table-column
            prop="quantityQz"
            label="(前置)数量"
            min-width="150"
            align="right"
            v-if="limit.quantity">
            <template slot-scope="scope">
              {{scope.row.ofoFlowWorkLimitShow.preQuantity}}
            </template>
          </el-table-column>
          <!-- 开始时间 -->
          <el-table-column
            prop="beginValue"
            label="开始时间"
            width="250"
            align="center"
            v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
          </el-table-column>
          <!-- 结束时间 -->
          <el-table-column
            prop="endValue"
            label="结束时间"
            width="250"
            align="center"
            v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
          </el-table-column>
          <el-table-column
            prop="quantity"
            label="时间(天)"
            width="150"
            v-if="ofoFlowWork.costmanagetype == '10'">
          </el-table-column>
          <!-- 时间期间 -->
          <el-table-column
            prop="quantity"
            label="时间期间"
            width="150"
            v-if="ofoFlowWork.costmanagetype == '7'">
            <template slot-scope="scope">{{scope.row.quantity | filter_handleTimeRange}}
            </template>
          </el-table-column>
          <!-- 单价 -->
          <el-table-column
            :prop="'price' + item.ofoFlowWorkConfigId"
            min-width="150"
            align="right"
            v-for="(item, index) in workConfig.workConfigList2"
            :key="item.ofoFlowWorkConfigId"
            :label="item.name"
            v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
            <template slot-scope="scope">
              <DictTag :options="JSON.parse(scope.row.workConfigList2[index].options)" :value="scope.row.workConfigList2[index].configValue" v-if="scope.row.workConfigList2[index].showType == '2'"/>
              <div v-else>
                {{scope.row.workConfigList2[index].configValue | comdify('no')}}
                <span v-if="scope.row.workConfigList2[index].showType == '1' && scope.row.workConfigList2[index].configValue">%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="price"
            align="right"
            min-width="150"
            label="单价（含税）"
            v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
            <template slot-scope="scope">{{comdifyPrams(scope.row.price)}}</template>
          </el-table-column>
          <el-table-column
            prop="priceKz"
            label="(控制)单价"
            min-width="150"
            align="right"
            v-if="limit.price && limit.price.limitRate">
            <template slot-scope="scope">
              {{scope.row.ofoFlowWorkLimitShow.price | comdify}}
            </template>
          </el-table-column>
          <el-table-column
            prop="priceQz"
            label="(前置)单价"
            min-width="150"
            align="right"
            v-if="limit.price">
            <template slot-scope="scope">
              {{scope.row.ofoFlowWorkLimitShow.prePrice | comdify}}
            </template>
          </el-table-column>
          <!-- 金额 -->
          <el-table-column
            :prop="'total' + item.ofoFlowWorkConfigId"
            min-width="150"
            align="right"
            v-for="(item, index) in workConfig.workConfigList3"
            :key="item.ofoFlowWorkConfigId"
            :label="item.name"
            v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '4' || ofoFlowWork.costmanagetype == '5'">
            <template slot-scope="scope">
              <DictTag :options="JSON.parse(scope.row.workConfigList3[index].options)" :value="scope.row.workConfigList3[index].configValue" v-if="scope.row.workConfigList3[index].showType == '2'"/>
              <div v-else>
                {{scope.row.workConfigList3[index].configValue | comdify('no')}}
                <span v-if="scope.row.workConfigList3[index].showType == '1' && scope.row.workConfigList3[index].configValue">%</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="total"
            align="right"
            min-width="150"
            header-align="center"
            label="金额（含税）"
            v-if="ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5'">
            <template slot-scope="scope">{{scope.row.total | comdify}}</template>
          </el-table-column>
          <el-table-column
            prop="lineTotalKz"
            label="(控制)金额"
            min-width="150"
            align="right"
            v-if="limit.lineTotal && limit.price.limitRate">
            <template slot-scope="scope">
              {{scope.row.ofoFlowWorkLimitShow.lineTotal | comdify}}
            </template>
          </el-table-column>
          <el-table-column
            prop="lineTotalQz"
            label="(前置)金额"
            min-width="150"
            align="right"
            v-if="limit.lineTotal">
            <template slot-scope="scope">
              {{scope.row.ofoFlowWorkLimitShow.preLineTotal | comdify}}
            </template>
          </el-table-column>
          <!-- 费用金额 -->
          <el-table-column
            prop="total"
            label="费用金额"
            min-width="200"
            align="right"
            header-align="center"
            v-if="ofoFlowWork.costmanagetype == '4'">
            <template slot-scope="scope">{{scope.row.price | comdify}}</template>
          </el-table-column>
          <!-- 税率 -->
          <el-table-column
            prop="vatgroup"
            label="税率"
            align="center"
            min-width="100"
            v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
            <template slot-scope="scope">
              <DictTag :options="dropDown.invoiceVat" :value="scope.row.vatgroup"/>
            </template>
          </el-table-column>
          <!-- 税额 -->
          <el-table-column
            prop="totalVat"
            label="税额"
            align="right"
            min-width="100"
            v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
            <template slot-scope="scope">{{scope.row.totalVat | comdify}}</template>
          </el-table-column>
          <!-- 票种 -->
          <el-table-column
            prop="invoicetype"
            label="票种"
            align="center"
            min-width="200"
            v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
            <template slot-scope="scope">
              <DictTag :options="dropDown.invoiceType" :value="scope.row.invoicetype"/>
            </template>
          </el-table-column>
          <!-- 成本单价 -->
          <el-table-column
            prop="cost"
            align="right"
            min-width="150"
            label="成本单价（含税）"
            v-if="ofoFlowWork.costmanagetype == '2'">
            <template slot-scope="scope">{{comdifyPrams(scope.row.cost)}}</template>
          </el-table-column>
          <!-- 成本金额 -->
          <el-table-column
            prop="costTotal"
            align="right"
            min-width="150"
            label="成本金额（含税）"
            v-if="ofoFlowWork.costmanagetype == '2'">
            <template slot-scope="scope">{{scope.row.costTotal | comdify}}</template>
          </el-table-column>
          <!-- 成本税额 -->
          <el-table-column
            prop="costTotalVat"
            label="成本税额"
            align="right"
            min-width="100"
            v-if="ofoFlowWork.costmanagetype == '2'">
            <template slot-scope="scope">{{scope.row.costTotalVat | comdify}}</template>
          </el-table-column>
          <!-- 备注 -->
          <el-table-column
            prop="remark"
            label="备注"
            min-width="150">
          </el-table-column>
        </el-table>
      </template>
    </el-table-column>
    <el-table-column
      type="index"
      label="行号"
      width="50">
    </el-table-column>
    <!-- 位置 -->
    <el-table-column
      prop="cbowhName"
      :label="cbowhName(1)"
      width="115"
      type=""
      v-if="ofoFlowWork.chooseOwh == '0' && (allShow || confirmResShow.includes('cbowhName'))">
    </el-table-column>
    <!-- 位置2 -->
    <el-table-column
      prop="cbowhToName"
      :label="cbowhName(2)"
      width="115"
      v-if="ofoFlowWork.stockaccttype == '7' && (allShow || confirmResShow.includes('cbowhToName'))">
    </el-table-column>
    <!-- 货物或应税劳务、服务名称 -->
    <el-table-column
      prop="ofrresourceName"
      :label="ofoFlowWork.kindtypeName"
      min-width="200"
      v-if="(allShow || confirmResShow.includes('ofrresourceName'))">
      <template slot-scope="scope">
        {{scope.row.ofrresourceName}}
      </template>
    </el-table-column>

    <template v-if="ofoFlowWork.costmanagetype != '9' && ofoFlowWork.ggdw === '0'">
      <el-table-column property="ggxh" prop="ggxh" width="250" show-overflow-tooltip label="规格型号" v-if="(allShow || confirmResShow.includes('ggxh'))"></el-table-column>
      <el-table-column property="jldw" prop="jldw" label="单位" v-if="(allShow || confirmResShow.includes('jldw'))"></el-table-column>
    </template>
    <template v-if="ofoFlowWork.costmanagetype == '9'">
      <el-table-column v-for="item in resDimeList" :key="item.cbdId" :label="item.dimeName" width="200" v-if="item.workshow == '0' && (allShow || confirmResShow.includes('dimension' + item.cbdId))" :prop="'dimension' + item.cbdId">
        <template slot-scope="scope">
          {{scope.row.dimensionList.find(val => val.cbdId == item.cbdId)?.dimeText}}
        </template>
      </el-table-column>
      <el-table-column :prop="jyjl" label="检验结论" width="150" v-if="allShow || confirmResShow.includes('jyjl')">
        <template slot-scope="scope">
          {{scope.row.beginValue == '0' ? '符合规定' : (scope.row.beginValue == '1' ? '不符合规定' : '')}}
        </template>
      </el-table-column>
    </template>
    <!-- 自定义 -->
    <el-table-column
      :prop="'customize' + item.ofoFlowWorkConfigId"
      min-width="150"
      align="center"
      v-for="(item, index) in workConfig.workConfigList4"
      :key="index"
      :label="item.name"
      v-if="!ofoFlowWork.thingtype && (allShow || confirmResShow.includes('customize' + item.ofoFlowWorkConfigId))">
      <template slot-scope="scope">
        <DictTag :options="JSON.parse(scope.row.workConfigList4[index].options)" :value="scope.row.workConfigList4[index].configValue" v-if="scope.row.workConfigList4[index].showType == '2'"/>
        <template v-else-if="scope.row.workConfigList4[index].showType == '1'">
          {{scope.row.workConfigList4[index].configValue}}
          <span v-if="scope.row.workConfigList4[index].showType == '1' && scope.row.workConfigList4[index].configValue">%</span>
        </template>
        <template v-else>
          {{scope.row.workConfigList4[index].configValue}}
        </template>
      </template>
    </el-table-column>

    <!-- 包装核算 -->
    <template v-if="params.bzhs === '0' && ofoFlowWork.bzhs === '0'">
      <el-table-column
        prop="bzsl"
        label="包装数量"
        min-width="150">
      </el-table-column>
      <el-table-column
        prop="bzdw"
        label="包装单位"
        min-width="120">
      </el-table-column>
      <el-table-column
        prop="bzxs"
        label="包装系数"
        min-width="120">
      </el-table-column>
    </template>

    <!-- <el-table-column v-for="(item, index) in obussDimeList" :key="index" :label="item.dimeName" :prop="item.dimeValue">
      <template slot-scope="scope">
        <span>{{scope.row.obussDimeList[index].dimeValue}}</span>
      </template>
    </el-table-column> -->
    <!-- 数量模式 -->
    <template v-if="ofoFlowWork.costmanagetype == '8'">
      <!-- 起始数量 -->
      <el-table-column
        prop="beginValue"
        label="起始数量"
        min-width="100"
        v-if="(allShow || confirmResShow.includes('beginValue'))">
      </el-table-column>
      <!-- 终止数量 -->
      <el-table-column
        prop="endValue"
        label="终止数量"
        min-width="100"
        v-if="(allShow || confirmResShow.includes('endValue'))">
      </el-table-column>
    </template>
    <!-- 数量 -->
    <el-table-column
      :prop="'quantity' + item.ofoFlowWorkConfigId"
      min-width="150"
      align="right"
      v-for="(item, index) in workConfig.workConfigList1"
      :key="item.ofoFlowWorkConfigId"
      :label="item.name"
      v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '8' && ofoFlowWork.costmanagetype != '4' && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('quantity' + item.ofoFlowWorkConfigId))">
      <template slot-scope="scope">
        <DictTag :options="JSON.parse(scope.row.workConfigList1[index].options)" :value="scope.row.workConfigList1[index].configValue" v-if="scope.row.workConfigList1[index].showType == '2'"/>
        <div v-else>
          {{scope.row.workConfigList1[index].configValue}}
          <span v-if="scope.row.workConfigList1[index].showType == '1' && scope.row.workConfigList1[index].configValue">%</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="quantity"
      label="数量"
      min-width="150"
      align="right"
      header-align="center"
      v-if="ofoFlowWork.costmanagetype != '7' && ofoFlowWork.costmanagetype != '10' && ofoFlowWork.costmanagetype != '4' && (allShow || confirmResShow.includes('quantity'))">
    </el-table-column>
    <el-table-column
      prop="quantityKz"
      label="(控制)数量"
      min-width="150"
      align="right"
      v-if="limit.quantity && !ofoFlowWork.thingtype && limit.quantity.limitRate && (allShow || confirmResShow.includes('quantityKz'))">
      <template slot-scope="scope">
        {{scope.row.ofoFlowWorkLimitShow.quantity}}
      </template>
    </el-table-column>
    <el-table-column
      prop="quantityQz"
      label="(前置)数量"
      min-width="150"
      align="right"
      v-if="limit.quantity && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('quantityQz'))">
      <template slot-scope="scope">
        {{scope.row.ofoFlowWorkLimitShow.preQuantity}}
      </template>
    </el-table-column>
    <!-- 时间期间 -->
    <template v-if="ofoFlowWork.costmanagetype == '7' || ofoFlowWork.costmanagetype == '10'">
      <!-- 开始时间 -->
      <el-table-column
        prop="beginValue"
        label="开始时间"
        width="250"
        align="center"
        v-if="(allShow || confirmResShow.includes('beginValue'))">
      </el-table-column>
      <!-- 结束时间 -->
      <el-table-column
        prop="endValue"
        label="结束时间"
        width="250"
        align="center"
        v-if="(allShow || confirmResShow.includes('endValue'))">
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="时间(天)"
        width="150"
        align="center"
        v-if="(ofoFlowWork.costmanagetype == '10' && (allShow || confirmResShow.includes('quantity')))">
      </el-table-column>
      <!-- 时间期间 -->
      <el-table-column
        prop="quantity"
        label="时间期间1"
        width="150"
        v-if="(ofoFlowWork.costmanagetype == '7' && (allShow || confirmResShow.includes('quantity')))">
        <template slot-scope="scope">{{scope.row.quantity | filter_handleTimeRange}}
        </template>
      </el-table-column>
    </template>

    <!-- 单价 -->
    <el-table-column
      :prop="'price' + item.ofoFlowWorkConfigId"
      min-width="150"
      align="right"
      v-for="(item, index) in workConfig.workConfigList2"
      :key="item.ofoFlowWorkConfigId"
      :label="item.name"
      v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('price' + item.ofoFlowWorkConfigId))">
      <template slot-scope="scope">
        <DictTag :options="JSON.parse(scope.row.workConfigList2[index].options)" :value="scope.row.workConfigList2[index].configValue" v-if="scope.row.workConfigList2[index].showType == '2'"/>
        <div v-else>
          {{scope.row.workConfigList2[index].configValue | comdify('no')}}
          <span v-if="scope.row.workConfigList2[index].showType == '1' && scope.row.workConfigList2[index].configValue">%</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="price"
      label="单价（含税）"
      min-width="150"
      align="right"
      v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && (allShow || confirmResShow.includes('price'))">
      <template slot-scope="scope">{{comdifyPrams(scope.row.price)}}</template>
    </el-table-column>
    <el-table-column
      prop="priceKz"
      label="(控制)单价"
      min-width="150"
      align="right"
      v-if="limit.price && !ofoFlowWork.thingtype && limit.price.limitRate && (allShow || confirmResShow.includes('priceKz'))">
      <template slot-scope="scope">
        {{scope.row.ofoFlowWorkLimitShow.price | comdify}}
      </template>
    </el-table-column>
    <el-table-column
      prop="priceQz"
      label="(前置)单价"
      min-width="150"
      align="right"
      v-if="limit.price && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('priceQz'))">
      <template slot-scope="scope">
        {{scope.row.ofoFlowWorkLimitShow.prePrice | comdify}}
      </template>
    </el-table-column>
    <!-- 金额 -->
    <el-table-column
      :prop="'total' + item.ofoFlowWorkConfigId"
      min-width="150"
      align="right"
      v-for="(item, index) in workConfig.workConfigList3"
      :key="item.ofoFlowWorkConfigId"
      :label="item.name"
      v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '4' || ofoFlowWork.costmanagetype == '5') && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('total' + item.ofoFlowWorkConfigId))">
      <template slot-scope="scope">
        <DictTag :options="JSON.parse(scope.row.workConfigList3[index].options)" :value="scope.row.workConfigList3[index].configValue" v-if="scope.row.workConfigList3[index].showType == '2'"/>
        <div v-else>
          {{scope.row.workConfigList3[index].configValue | comdify('no')}}
          <span v-if="scope.row.workConfigList3[index].showType == '1' && scope.row.workConfigList3[index].configValue">%</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column
      prop="total"
      label="金额（含税）"
      min-width="150"
      align="right"
      header-align="center"
      v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && (allShow || confirmResShow.includes('total'))">
      <template slot-scope="scope">{{scope.row.total | comdify}}</template>
    </el-table-column>
    <el-table-column
      prop="lineTotalKz"
      label="(控制)金额"
      min-width="150"
      align="right"
      v-if="limit.lineTotal && !ofoFlowWork.thingtype && limit.price.limitRate && (allShow || confirmResShow.includes('lineTotalKz'))">
      <template slot-scope="scope">
        {{scope.row.ofoFlowWorkLimitShow.lineTotal | comdify}}
      </template>
    </el-table-column>
    <el-table-column
      prop="lineTotalQz"
      label="(前置)金额"
      min-width="150"
      align="right"
      v-if="limit.lineTotal && !ofoFlowWork.thingtype && (allShow || confirmResShow.includes('lineTotalQz'))">
      <template slot-scope="scope">
        {{scope.row.ofoFlowWorkLimitShow.preLineTotal | comdify}}
      </template>
    </el-table-column>
    <!-- 费用金额 -->
    <el-table-column
      prop="total"
      label="费用金额"
      min-width="200"
      align="right"
      header-align="center"
      v-if="ofoFlowWork.costmanagetype == '4' && (allShow || confirmResShow.includes('total'))">
      <template slot-scope="scope">{{scope.row.total | comdify}}</template>
    </el-table-column>
    <template v-if="(ofoFlowWork.costmanagetype == '1' || ofoFlowWork.costmanagetype == '2' || ofoFlowWork.costmanagetype == '3' || ofoFlowWork.costmanagetype == '5') && !(ofoFlowDeal.dealtype == '4' || ofoFlowDeal.dealtype == '3')">
      <!-- 税率 -->
      <el-table-column
        prop="vatgroup"
        label="税率"
        align="center"
        min-width="100"
        v-if="(allShow || confirmResShow.includes('vatgroup'))">
        <template slot-scope="scope">
          <DictTag :options="dropDown.invoiceVat" :value="scope.row.vatgroup"/>
        </template>
      </el-table-column>
      <!-- 税额 -->
      <el-table-column
        prop="totalVat"
        label="税额"
        align="right"
        min-width="100"
        v-if="(allShow || confirmResShow.includes('totalVat'))">
        <template slot-scope="scope">{{scope.row.totalVat | comdify}}</template>
      </el-table-column>
      <!-- 票种 -->
      <el-table-column
        prop="invoicetype"
        label="票种"
        align="center"
        min-width="200"
        v-if="(allShow || confirmResShow.includes('invoicetype'))">
        <template slot-scope="scope">
          <DictTag :options="dropDown.invoiceType" :value="scope.row.invoicetype"/>
        </template>
      </el-table-column>
    </template>
    <!-- 成本 -->
    <template v-if="ofoFlowWork.costmanagetype == '2'">
      <!-- 成本单价 -->
      <el-table-column
        prop="cost"
        align="right"
        min-width="150"
        label="成本单价（含税）"
        v-if="(allShow || confirmResShow.includes('cost'))">
        <template slot-scope="scope">{{comdifyPrams(scope.row.cost)}}</template>
      </el-table-column>
      <!-- 成本金额 -->
      <el-table-column
        prop="costTotal"
        align="right"
        min-width="150"
        label="成本金额（含税）"
        v-if="(allShow || confirmResShow.includes('costTotal'))">
        <template slot-scope="scope">{{scope.row.costTotal | comdify}}</template>
      </el-table-column>
      <!-- 成本税额 -->
      <el-table-column
        prop="costTotalVat"
        label="成本税额"
        align="right"
        min-width="100"
        v-if="(allShow || confirmResShow.includes('costTotalVat'))">
        <template slot-scope="scope">{{scope.row.costTotalVat | comdify}}</template>
      </el-table-column>
    </template>

    <!-- 备注 -->
    <el-table-column
      prop="remark"
      label="备注"
      min-width="150"
      v-if="(allShow || confirmResShow.includes('remark'))">
    </el-table-column>
  </el-table>
</template>

<style scoped lang="scss">

</style>
